import LandingFormContainer from './LandingFormContainer';

export default LandingFormContainer;
